'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _site = require('./site.component');

var _site2 = _interopRequireDefault(_site);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteModule = _angular2.default.module('site', [_angularUiRouter2.default]).component('site', _site2.default);

exports.default = siteModule;


// WEBPACK FOOTER //
// ./client/app/common/admin/site/site.js